module.exports = __webpack_public_path__ + "static/media/tc.bfe93186.svg";